export var BOTPRESS_LOADED_EVENT = 'botpress:loaded';
export var BOTPRESS_WEBCHAT_OPENED_EVENT = 'webchat:opened';
export var BOTPRESS_WEBCHAT_CLOSED_EVENT = 'webchat:closed';
export var BOTPRESS_CUSTOM_EVENT = 'customEvent';
export var BOTPRESS_GOOGLE_ANALYTICS_EVENT = 'glammatic:ga';
export var BOTPRESS_USER_LINK_CLICK_EVENT = 'user:linkClick';
export var VARIANT_SOFT = 'soft';
export var VARIANT_SOLID = 'solid';
export var THEME_MODE_LIGHT = 'light';
export var THEME_MODE_DARK = 'dark';
export var BOTPRESS_DEFAULT_CONFIG = {
  composerPlaceholder: 'Ask something here!',
  botName: 'Customer service',
  botAvatar: '',
  botDescription: '',
  color: '',
  variant: VARIANT_SOFT,
  themeMode: THEME_MODE_LIGHT,
  additionalStylesheetUrl: 'https://files.bpcontent.cloud/2025/01/17/12/20250117122026-9WQL43NW.css',
  fontFamily: undefined,
  radius: 4,
  email: {},
  phone: {},
  website: {},
  termsOfService: {},
  privacyPolicy: {},
  allowFileUpload: false
};
export var BOTPRESS_NOTIFICATION_CONTAINER_ID = 'botpress-notification-container';